import { Injectable } from '@angular/core';
import { 
// Route,
Router, 
// RouterStateSnapshot,
// UrlSegment,
UrlTree } from '@angular/router';
import { UsersService } from '@innersight-os/shared/firebase-services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  iAmAuthorised$ = this.users.myOnboardingStage$.pipe(
    map(stage => stage === 'onboarded')
  );

  redirectToLoginPage$ = this.iAmAuthorised$.pipe(
    map(authed => authed || this.router.parseUrl('/user/login'))
  )

  constructor(
    private users: UsersService,
    private router: Router,
  ){}

  canActivate(
    // next: ActivatedRouteSnapshot,
    // state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.redirectToLoginPage$
  }

  canActivateChild(
    // next: ActivatedRouteSnapshot,
    // state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.redirectToLoginPage$
  }

  canLoad(
    // route: Route,
    // segments: UrlSegment[]
  ): Observable<boolean> {
    return this.iAmAuthorised$
  }
}
